var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("merchantAccount.cancel_cash_out"),
            width: "800px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "diglog-container" },
            [
              _c("div", { staticClass: "header-line" }),
              _c("div", { staticClass: "section-title" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("merchantAccount.cancel_reason")) + ": "
                ),
              ]),
              _c(
                "el-form",
                {
                  ref: "cancelForm",
                  attrs: {
                    model: _vm.cancelForm,
                    rules: _vm.cancelRules,
                    "status-icon": "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "reason" } },
                            [
                              _c("el-input", {
                                staticClass: "cancel-reason-input",
                                attrs: {
                                  type: "textarea",
                                  rows: 6,
                                  maxlength: "200",
                                  "show-word-limit": "",
                                  autocomplete: "off",
                                  placeholder: _vm.$t(
                                    "merchantAccount.cancel_reason_placeholder"
                                  ),
                                },
                                model: {
                                  value: _vm.cancelForm.reason,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cancelForm, "reason", $$v)
                                  },
                                  expression: "cancelForm.reason",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "info", disabled: _vm.submiting },
                  on: { click: _vm.onClickSubmitBtn },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }